import baseapi from "../baseAPI";
//import {successMesg, errorMesg, infoMessage, warningMesg} from "./../../Pages/Toaster";

export const CampaignListAPI = async (setCampaigns, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("api/sales/campaigns?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.data.data);
        
        setCampaigns(response.data.datalist.data);
        setLoading(false);

        if(response.data.datalist.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const CampaignReportAPI = async (setFreshLeadCount, setWarmLeadCount, setTodayFollowupCount, setPendingFollowupCount, setLoading, campaignid, setCampaignName) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/sales/campaign/report/" + campaignid);

        //console.log("Data got successfully", response.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        /*setTotalLeadCount(response.data.data.totalcount);
        setAssignedLeadCount(response.data.data.assignedlead);
        setPendingLeadCount(response.data.data.pendinglead);
        setNoAnswerLeadCount(response.data.data.noresponselead);
        setTodayLeadCount(response.data.data.todaylead);
        setCalledLeadCount(response.data.data.calledlead);
        setConvertedLeadCount(response.data.data.enrollledlead);
        setNotInterestLeadCount(response.data.data.notinterestedlead);
        setCallBackLeadCount(response.data.data.callbacklead);
        setNextYearLeadCount(response.data.data.nextyearlead);*/
        setCampaignName(response.data.datalist.name);
        setFreshLeadCount(response.data.datalist.fresh_lead);
        setWarmLeadCount(response.data.datalist.warm_lead);
        setTodayFollowupCount(response.data.datalist.today_followup);
        setPendingFollowupCount(response.data.datalist.pending_followup);
        //setLeads(response.data.leads.data);
        setLoading(false);

    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }

}

export const CampaignLeadsAPI = async (setLeads, campaignid, currentPage, perpagedata, setPageCount, setLeadLoading) =>
{
    
    try
    {
        const response = await baseapi.get("/api/sales/campaign/lead/" + campaignid + "?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setLeads(response.data.leads.data);
        setLeadLoading(false);

        if(response.data.leads.data.length > 0)
        {
            //console.log('Total count====='+response.data.total);
            let pagecount = Math.ceil(response.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }

    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLeadLoading(false);
    }

}


